import { ChangeEvent, forwardRef, ForwardRefRenderFunction } from 'react';
import styles from './style.module.css';

export interface IRadioCardOption {
  value: string;
  label: string;
  icon?: string;
}

interface IRadioCardGroup {
  name: string;
  options: IRadioCardOption[];
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  errors?: string;
  label?: string | JSX.Element;
}

const RadioCardGroupBase: ForwardRefRenderFunction<
  HTMLInputElement,
  IRadioCardGroup
> = ({ name, options, value, onChange, onBlur, errors, label }, ref) => {
  return (
    <>
      {label && <label>{label}</label>}
      <div className={styles.grid}>
        {options.map((option, index) => (
          <label
            key={option.value}
            className={`${styles.card} ${
              value === option.value ? styles.cardChecked : ''
            }`}
          >
            <div className={styles.body}>
              {option.icon && (
                <span className={styles.icon}>
                  <i className="material-icons-outlined">{option.icon}</i>
                </span>
              )}
              <span className={styles.label}>{option.label}</span>
            </div>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              onBlur={onBlur}
              ref={index === 0 ? ref : undefined}
            />
          </label>
        ))}
      </div>
      <span className={styles.error}>{errors}</span>
    </>
  );
};

export const RadioCardGroup = forwardRef(RadioCardGroupBase);
